import HeroSection from './HeroSection';
import PerformancesSection from './PerformancesSection';
import CertificatesSection from './CertificatesSection';
import SkillsSection from './SkillsSection';
import AchievementsSection from './AchievementsSection';
import ProjectsSection from './ProjectsSection';

const Music = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <PerformancesSection />
      <SkillsSection />
      <CertificatesSection />
      <AchievementsSection />
      <ProjectsSection />
    </div>
  );
};

export default Music;
